export default {
  name: 'mixClickableCell',
  props: {
    damageId: {
      type: Number | String,
      required: true
    },
    isMixEnabled: {
      type: Boolean,
      default: true
    },
    type: {
      type: 'GAG' | 'REN' | 'ASP',
      required: true
    },
    repTypeSelected: {
      type: 'GAG' | 'REN' | 'ASP',
      required: true
    },
    selected: {
      type: Boolean,
      default: false,
      required: false
    }
  },
  computed: {
    isSelected: () => {
      return this.type === this.repTypeSelected
    }
  },

  methods: {
    handleOnClick() {
      if (this.isMixEnabled && this.damageId) {
        this.$emit('selected', { damageId: this.damageId, repType: this.type })
      }
    }
  }
}
